import { FC } from 'react';
import { BookingClinic } from 'entities/booking/store/types';
import plural from 'plural-ru';
import styles from './styles.module.scss';
import { ButtonContained } from 'shared/ui/buttons/buttonContained';

interface ClinicCounterButtonProps {
	selectedClinics: BookingClinic[];
	selectClinics: () => void;
}

export const ClinicCounterButton: FC<ClinicCounterButtonProps> = ({
	selectedClinics,
	selectClinics,
}) => {
	const count = selectedClinics.length;
	return (
		<div className={styles['selected-clinics-summary']}>
			<div className={styles['selected-clinics-summary__text']}>
				{count
					? `Поиск по ${count} ${plural(count, 'клинике', 'клиникам')}`
					: 'Поиск по всем клиникам'}
			</div>
			<ButtonContained
				className={styles['selected-clinics-summary__button']}
				variant={'primary'}
				onClick={selectClinics}
				isFullWidth={true}
			>
				Далее
			</ButtonContained>
		</div>
	);
};
